<template>
  <div class="serve-cost-record">
    <headBox title="服务费记录" class="headerBox"> </headBox>
    <div class="header">
      <topSearchForm @search="searchAjax()" @export="exportPolicyExcel" :hiddenExport="false">
        <el-form :inline="true">
          <el-form-item label="保单号" class="item">
            <el-input v-model="searchParams.policyNo" style="width: 100%" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称" class="item">
            <el-input v-model="searchParams.productName" style="width: 100%" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item label="" class="item">
            <el-input v-model="insureName" clearable placeholder="请输入">
              <el-select v-model="level" style="width: 88px" placeholder="请选择" slot="prepend">
                <el-option label="投保人" value="1"></el-option>
                <el-option label="被保人" value="2"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="出单团队" class="item item-chudan" v-if="[1, 2].includes(userinfo.userLevel) && [1, 2].includes(userinfo.level * 1)">
            <el-select class="right-select" v-model="searchParams.mechanId" clearable filterable>
              <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="activeName == 'first' && userinfo.level == 1" label="结算状态" class="item">
            <el-radio-group v-model="searchParams.balanceStatus" @change="searchAjax()" style="width: 100%">
              <el-radio :label="2">全部</el-radio>
              <el-radio :label="1">已结算</el-radio>
              <el-radio :label="0">未结算</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </topSearchForm>
    </div>
    <div class="body">
      <el-tabs
        v-model="activeName"
        @tab-click="searchAjax()"
        v-if="['2', '1'].includes(userinfo.level) && [1, 2].includes(userinfo.userLevel * 1) && userinfo.isOpenMechanism == 1"
      >
        <el-tab-pane label="我的服务费记录" name="first"></el-tab-pane>
        <el-tab-pane label="下级团队服务费记录" name="second"></el-tab-pane>
      </el-tabs>

      <el-table :data="tableData" border class="omtable" style="width: 100%" tooltip-effect="dark" v-loading="listLoading" row-key="id">
        <el-table-column prop="policyNo" label="保单号" :key="Math.random()" min-width="200px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.policyNo }}
          </template>
        </el-table-column>

        <el-table-column prop="mechanShortName" :key="Math.random()" label="出单团队" min-width="200px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.mechanShortName }}
          </template>
        </el-table-column>

        <el-table-column
          v-if="activeName == 'second'"
          :key="Math.random()"
          prop="spcMechanName"
          label="服务费归属"
          min-width="200px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ scope.row.spcMechanName }}
          </template>
        </el-table-column>

        <el-table-column prop="productName" :key="Math.random()" label="险种名称" min-width="200px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.additionPolicyId" class="fijiaxian">附</span>
            {{ scope.row.productName }}
          </template>
        </el-table-column>

        <el-table-column prop="policyerName" :key="Math.random()" label="投 / 被保人" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope"> {{ scope.row.policyerName }} / {{ scope.row.insuranceName }} </template>
        </el-table-column>

        <el-table-column prop="payNum" :key="Math.random()" label="结算期数" width="120">
          <template slot-scope="{ row }">
            {{ row.isPostf == 1 ? '首期后置' : getPayNum(row.payNum) }}
          </template>
        </el-table-column>

        <el-table-column prop="policyStatus" :key="Math.random()" label="保单状态" width="120">
          <template slot-scope="{ row }">
            {{ all.POLICY_STATUS[row.policyStatus] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="renewalStatus" :key="Math.random()" label="续费状态" width="120">
          <template slot-scope="{ row }">
            <span v-if="row.renewalStatus == 1">待续费</span>
            <span v-else-if="row.renewalStatus == 2">续费成功</span>
            <span v-else-if="row.renewalStatus >= 3">续费失败</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="fee" :key="Math.random()" label="保费(元)" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.fee }}
          </template>
        </el-table-column>

        <el-table-column
          :key="Math.random()"
          prop="commissionVal"
          label="基础服务费率 / 服务费(元)"
          min-width="140px"
          width="180"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.commissionVal"> {{ scope.row.commissionVal }}% / {{ scope.row.incomes }} </span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column
          :key="Math.random()"
          prop="subsidyCommissionVal"
          label="活动服务费率 / 服务费(元)"
          min-width="140px"
          width="180"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.subsidyCommissionVal"> {{ scope.row.subsidyCommissionVal }}% / {{ scope.row.subsidyIncomes }} </span>
            <span v-else>-</span>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <div style="text-align: left">活动名称：{{ scope.row.activityName }}</div>
                <div style="text-align: left">
                  活动时间：{{ scope.row.activityStartTime | formatDate('yyyy/MM/dd') || '-' }}
                  至
                  {{ scope.row.activityEndTime | formatDate('yyyy/MM/dd') || '-' }}
                </div>
              </div>
              <span class="icon-wenhao1 wenhao" v-show="scope.row.activityName"></span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column :key="Math.random()" prop="totalIncomes" label="总服务费(元)" min-width="140px" width="180" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.totalIncomes }}
          </template>
        </el-table-column>

        <el-table-column
          :key="Math.random()"
          prop="subTotalCommissionVal"
          label="下级团队服务费率 /服务费(元)"
          min-width="140px"
          width="200"
          :show-overflow-tooltip="true"
          v-if="activeName == 'first' && userinfo.level == 1"
        >
          <div slot-scope="scope">
            <span v-if="scope.row.subTotalCommissionVal"> {{ scope.row.subTotalCommissionVal }}% / {{ scope.row.subIncomes }}</span>
            <span v-else>-</span>
          </div>
        </el-table-column>

        <el-table-column
          :key="Math.random()"
          prop="profit"
          min-width="140px"
          width="180"
          :show-overflow-tooltip="true"
          v-if="activeName == 'first' && userinfo.level == 1"
        >
          <template slot="header">
            <span>
              净收入(元)
              <el-tooltip class="item" effect="dark" content="团队纯利润收入（不含下级）" placement="top">
                <span class="icon-wenhao1 wenhao"></span>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>

        <el-table-column
          :key="Math.random()"
          v-if="activeName == 'first'"
          prop="balanceStatus"
          label="结算状态"
          min-width="140px"
          width="180"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.balanceStatus == 1">已结算</span>
            <span v-else-if="scope.row.balanceStatus == 0">未结算</span>
            <span v-else-if="scope.row.balanceStatus == -1">不符合结算条件</span>
            <el-tooltip
              class="item"
              effect="dark"
              placement="top"
              @mouseenter.native="openRecord(scope.row, scope.index)"
              v-if="scope.row.balanceStatus == 1"
              :openDelay="300"
            >
              <div slot="content" style="min-width: 360px; white-space: nowrap">
                <div v-for="(bean, i) in recordList" :key="i" style="display: flex">
                  <div>{{ bean.balanceDate }}</div>
                  <div style="min-width: 120px; margin-left: 20px">结算保费(元)：{{ bean.fee }}</div>
                  <div style="margin-left: 20px">结算金额(元)：{{ bean.incomeTax }}</div>
                </div>
                <div v-if="recordList.length == 0 && recordLoading">加载中</div>
                <div v-else-if="recordList.length == 0">无数据</div>
              </div>
              <i class="icon-wenhao1 wenhao"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="page"
        background
        :current-page.sync="pageNum"
        :page-size.sync="pageSize"
        :layout="$tools.pageLayout"
        :total="total"
        @size-change="
          pageNum = 1;
          pageSize = $event;
          getList();
        "
        @current-change="getList"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { pageTool, common } from '@/api/mixins';
import headBox from '@/components/head.vue';
import topSearchForm from '@/components/topSearchForm';

//当前实例组件
export default {
  mixins: [common, pageTool],
  data: () => ({
    userinfo: {},
    searchParams: {
      type: '1',
      balanceStatus: 2
    },
    activeName: 'first',
    tableData: [],
    all: {},
    loading: false,
    level: '1',
    insureName: '',
    totalData: {
      profitSum: '',
      totalIncomesSum: '',
      policyNum: '',
      feeSum: '',
      subIncomesSum: ''
    },
    selectList: [],
    recordList: [],
    recordLoading: false
  }),
  components: { headBox, topSearchForm },
  mounted() {
    this.userinfo = this.$tools.getLocal('userinfo');
    this.all = this.$tools.getLocal('all');
    this.getList();
    this.initListAjax('/master/policy/queryPolicyCommissons');
    if (this.userinfo.level == 1 || (this.userinfo.level == 2 && this.userinfo.userLevel == 2)) {
      // 一级机构/二级团队 展示出单团队
      this.getChildList();
    }
  },
  methods: {
    // 搜索
    searchAjax(url = '') {
      if (url) {
        this.listUrl = url;
      }
      this.listLoading = true;
      this.pageNum = 1;
      this.tableData = [];
      clearTimeout(this.timer);
      this.timer = setTimeout(_ => {
        this.getList();
      }, 500);
    },
    setListParams(params) {
      if (this.level == 1) {
        params.policyerName = this.insureName;
      } else if (this.level == 2) {
        params.insuranceName = this.insureName;
      }
      if (params.balanceStatus == 2) {
        delete params.balanceStatus;
      }
      if (this.activeName == 'first') {
        params.type = 1;
      } else {
        params.type = 2;
      }
    },
    listCallback(res) {
      this.totalData = res.statistics;
    },
    //导出excel
    exportPolicyExcel() {
      const params = Object.assign({}, this.searchParams);
      this.setListParams(params);
      this.$tools.daochu(this.$config.api_root + '/master/policy/exportPolicyCommissons', params);
    },
    // 获取团队/员工列表
    getChildList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {
          includeFirst: '1'
        }
      }).then(res => {
        if (res.httpCode == 200) {
          this.selectList = res.data;
        }
      });
    },
    openRecord(item, i) {
      let obj = {
        type: this.activeName == 'first' ? 1 : 2
      };
      if (item.isPostf == 1) {
        //后置费用
        obj.policyCommissonsPostfId = item.id;
      } else {
        obj.policyCommissonsId = item.id;
      }
      this.recordLoading = true;
      this.recordList = [];
      console.log(obj);
      this.$http({
        url: '/master/policy/queryCommissonsBalancePolicy',
        type: 'PUT',
        params: obj
      })
        .then(res => {
          this.recordList = res.data;
        })
        .finally(() => {
          this.recordLoading = false;
        });
    },
    /**
     * 根据期数编码获取中文期数显示
     * @param num - 期数编码（1表示首年，其他数字返回对应第n年）
     * @returns 中文期数显示文本
     */
    getPayNum(num) {
      if (num == '1') return '首年'
      const n = parseInt(num)
      const chineseMap = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      // 处理 10-99 的两位数
      if (n >= 10 && n < 100) {
        const ten = Math.floor(n / 10)
        const unit = n % 10
        // 十位数为1时读作"十"（如10读"十"而非"一十"）
        let str = ten === 1 ? '十' : chineseMap[ten] + '十'
        if (unit > 0) {
          str += chineseMap[unit]
        }
        return `第${str}年`
      }
      // 处理 2-9 的个位数
      const chineseNum = String(num).split('').map(d => chineseMap[parseInt(d)]).join('')
      return `第${chineseNum}年`
    }
  }
};
</script>
<style lang="scss" scoped>
@import './serveCostRecord';
</style>
